import { isAxiosError } from '../../isAxiosError';
import localAxios from '../../localAxios';
import { ActivityInsights, activityInsightsSchema } from './insightSchema';
import { getActivityInsightsURL } from './URLs';

export async function getActivityInsights(
  activityInstanceId: number
): Promise<ActivityInsights> {
  try {
    const url = getActivityInsightsURL(activityInstanceId);
    const response = await localAxios.get<unknown>(url.href);

    if (!response.data) {
      return null;
    }
    const { data, error } = activityInsightsSchema.safeParse(response.data);
    if (error) {
      throw new Error(error.message);
    }
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.code === '404') {
        return null;
      }
    }

    throw error;
  }
}
